import type { FormTemplate } from '@wix/ambassador-forms-v1-form-template/types';
import { type CountryCode } from '@wix/form-multiline-address';
import { createContext, useContext } from 'react';

import { type AddressTemplate } from '../types';

export type AddressFormsContextProps = {
  getCountryAddressForm: (country?: CountryCode) => FormTemplate | undefined;
  addressTemplates?: AddressTemplate[];
};

const initialState: AddressFormsContextProps = {
  getCountryAddressForm: () => undefined,
  addressTemplates: undefined,
};

export const AddressFormsContext =
  createContext<AddressFormsContextProps>(initialState);

export const getAddressForm = (
  templates?: AddressTemplate[],
  country?: CountryCode,
) => {
  return (
    templates?.find((template) => template.country === country)?.template ||
    templates?.find((template) => template.country === 'COMMON')?.template
  );
};

export function useAddressForms() {
  const context = useContext(AddressFormsContext);
  if (context === undefined) {
    throw new Error(
      'useAddressForms must be used within a AddressFormsContext',
    );
  }

  return context;
}
